import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import UriUtils from '../modules/UriUtils';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const WaterService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}`;

  service.getWaterAccountBySearch = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    const queryString = UriUtils.toQueryString(criteria);
    return axios.get(`${BASE_URL}/water-account/search${queryString}`, {
      headers,
    });
  };

  service.getWaterBillsByAccountId = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    const queryString = UriUtils.toQueryString(criteria);
    return axios.get(`${BASE_URL}/water-account/bills/search${queryString}`, {
      headers,
    });
  };

  service.bulkLinkToAccount = ({ serviceOfferingId, customerId, bulkId, }) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    return axios.post(
      `${BASE_URL}/water-account/accounts/bulk/link`,
      {
        serviceOfferingId,
        customerId,
        bulkId,
      },
      {
        headers,
      }
    );
  };

  service.bulkUnlinkFromAccount = ({ serviceOfferingId, customerId, bulkId, }) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    return axios.post(
      `${BASE_URL}/water-account/accounts/bulk/unlink`,
      {
        serviceOfferingId,
        customerId,
        bulkId,
      },
      {
        headers,
      }
    );
  };

  service.retryManualAll = ({ serviceOfferingId, transactionId, forceRepostToClient, }) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(`${BASE_URL}/water/retry/all`, {
      serviceOfferingId,
      transactionId,
      forceRepostToClient,
    }, { headers, });
  };

  service.retryManualSingle = ({ serviceOfferingId, transactionId, lineItemId, externalPayableId, forceRepostToClient, }) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(`${BASE_URL}/water/retry/single`, {
      serviceOfferingId,
      transactionId,
      lineItemId,
      externalPayableId,
      forceRepostToClient,
    }, { headers, });
  };

  service.getServiceOfferings = () => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    return axios.get(`${BASE_URL}/water-offerings`, {
      headers,
    });
  };

  return service;
})();

export default WaterService;
